import { FC } from "react";
import CategoriesSkin1 from "./skins/skin-1/categories-skin-1";
import CategoriesSkin3 from "./skins/skin-3/categories-skin-3";
import CategoriesSkin4 from "./skins/skin-4/categories-skin-4";
import CategoriesSkin5 from "./skins/skin-5/categories-skin-5";
import CategoriesSkin6 from "./skins/skin-6/categories-skin-6";
import styles from "./categories.module.css";
import {
  WidgetProps,
  WidgetType } from
"@commons-monorepo/index";
import { CategoriesContext } from "./categories.context";

const Categories: FC<WidgetProps<string[], {}>> = ({
  theme,
  data,
  storeMetadata,
  id,
  type
}) => {
  const { Provider } = CategoriesContext;
  const providerValue = {
    theme,
    data,
    partnerId: storeMetadata?.userNetwork?.urlSummer,
    storeMetadata
  };

  return (
    <Provider value={providerValue}>
      <div id={id} className={styles.categoriesContainer}>
        {(type === WidgetType.CATEGORIES_SKIN_1 ||
        type === WidgetType.CATEGORIES_SKIN_2) &&
        <CategoriesSkin1 type={type} />}

        {type === WidgetType.CATEGORIES_SKIN_3 && <CategoriesSkin3 />}
        {type === WidgetType.CATEGORIES_SKIN_4 && <CategoriesSkin4 />}
        {type === WidgetType.CATEGORIES_SKIN_5 &&
        <CategoriesSkin5 fullWidth={theme.templateId === "MADRID"} />}

        {type === WidgetType.CATEGORIES_SKIN_6 && <CategoriesSkin6 />}
      </div>
    </Provider>);

};

export default Categories;